import React, { useContext } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { StateContext } from "../../StateContext";
import { kebabize } from "../../helpers/inflection";
import useVenue from "../../hooks/useVenue";
import BeerList from "../BeerList";
import Tile from "../Tile";
import { NavLink as Link } from "../TrackedLink";

import * as styles from "./styles.module.scss";

const BeerLists = () => {
  const { isEltham, venue } = useVenue();
  const state = useContext(StateContext);
  const location = useLocation();
  const menus = state.menus.filter((menu) => menu.venue === venue);

  return (
    <>
      {isEltham && menus.length > 1 && (
        <div className={styles.buttonsContainer}>
          <div>
            {menus.map((menu, index) => {
              const base = `/${venue.toLowerCase()}/drinks`;
              const to = `${base}/${kebabize(menu.name)}`;
              const isActive =
                location.pathname === to ||
                (location.pathname === base && index === 0);
              return (
                <Link key={menu.untappdId} to={to}>
                  <Tile
                    text={menu.name}
                    isActive={isActive}
                    key={menu.untappdId}
                  />
                </Link>
              );
            })}
          </div>
        </div>
      )}
      <Routes>
        <Route key="index" path="/" element={<BeerList menu={menus[0]} />} />

        {menus.map((menu) => {
          return (
            <Route
              key={menu.name}
              path={`/${kebabize(menu.name)}`}
              element={<BeerList menu={menu} />}
            />
          );
        })}
      </Routes>
    </>
  );
};

export default BeerLists;
